import { ColorRecipeModel } from '../edit/models/color-recipe.model';
import { Store } from '@ngxs/store';
import { EngineState } from './state/engine.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { EngineService } from './engine.service';
import { PaintPresetOriginal, PaintPresetFade } from './models/paint-presets.const';
import { ObjectColor } from '../shared/object-color';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../../lib/graph/graph.service";
import * as i3 from "./engine.service";
var PaintService = /** @class */ (function () {
    function PaintService(store, graphService, engineService) {
        this.store = store;
        this.graphService = graphService;
        this.engineService = engineService;
        this.highlightDisabled = false;
    }
    PaintService.prototype.colorObject = function (objectId, params) {
        var humanObject = Human.scene.objects[objectId];
        if (humanObject instanceof Human.scene.Object) {
            // to clear or not to clear, that is the question
            // apply mod properties that are not default
            if (params.hasOwnProperty('tintColor')) {
                humanObject.setTintColor(params.tintColor);
            }
            if (params.hasOwnProperty('saturation')) {
                humanObject.setSaturation(params.saturation);
            }
            if (params.hasOwnProperty('brightness')) {
                humanObject.setBrightness(params.brightness);
            }
            if (params.hasOwnProperty('contrast')) {
                humanObject.setContrast(params.contrast);
            }
            if (params.hasOwnProperty('opacity')) {
                humanObject.setOpacity(params.opacity);
            }
        }
    };
    PaintService.prototype.getColor = function (objectId) {
        return ObjectColor.getColorRecipe(Human, objectId);
    };
    PaintService.prototype.uncolorObject = function (objectId) {
        var object = Human.scene.objects[objectId];
        if (object instanceof Human.scene.Object) {
            object.clearColorModifiers();
            object.clearOpacityModifiers();
        }
    };
    PaintService.prototype.unpaint = function (node) {
        var _this = this;
        // relay color mods to each engine leaf
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        this.graphService.getLeafDescendants(viewGraph, node.id).forEach(function (id) {
            _this.engineService.getObjects(id).forEach(function (humanObjectId) {
                var humanObject = Human.scene.objects[humanObjectId];
                if (humanObject instanceof Human.scene.Object) {
                    // reset object mod properties
                    humanObject.clearColorModProperties();
                    humanObject.clearOpacityModProperties();
                }
            });
        });
    };
    PaintService.prototype.paint = function (node, recipe) {
        var _this = this;
        // relay color mods to each engine leaf
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var engineRecipe = ColorRecipeModel.toEngine(recipe);
        this.graphService.getLeafDescendants(viewGraph, node.id).forEach(function (id) {
            _this.engineService.getObjects(id).forEach(function (humanObjectId) {
                _this.uncolorObject(humanObjectId);
                _this.colorObject(humanObjectId, engineRecipe);
            });
        });
    };
    PaintService.prototype.highlight = function (node, highlight) {
        var _this = this;
        // allow un-highlight if highlight is disabled
        if (this.highlightDisabled === false || highlight === false) {
            // relay highlight to each engine leaf
            var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            this.graphService.getLeafDescendants(viewGraph, node.id).forEach(function (id) {
                _this.engineService.getObjects(id).forEach(function (humanObjectId) {
                    var humanObject = Human.scene.objects[humanObjectId];
                    if (humanObject instanceof Human.scene.Object) {
                        humanObject.setHighlight(highlight);
                    }
                });
            });
        }
    };
    PaintService.prototype.xRay = function (node, xRay) {
        var object = Human.scene.objects[node.id];
        object.setXRay(xRay);
    };
    PaintService.prototype.paintAll = function (nodes, recipe) {
        var _this = this;
        nodes.forEach(function (node) {
            _this.paint(node, recipe);
        });
    };
    PaintService.prototype.highlightAll = function (nodes, highlight) {
        var _this = this;
        nodes.forEach(function (node) {
            _this.highlight(node, highlight);
        });
    };
    PaintService.prototype.inverseXRay = function (nodes, viewGraph) {
        var nodeIds = nodes.map(function (node) { return node.id; });
        var inverseNodeIds = this.graphService.getInverseSelection(viewGraph, nodeIds);
        var inverseNodes = this.graphService.getNodes(viewGraph, inverseNodeIds);
        this.paintAll(inverseNodes, PaintPresetFade.recipe);
        this.paintAll(nodes, PaintPresetOriginal.recipe);
    };
    PaintService.prototype.disableHighlight = function () {
        this.highlightDisabled = true;
    };
    PaintService.prototype.enableHighlight = function () {
        this.highlightDisabled = false;
    };
    PaintService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaintService_Factory() { return new PaintService(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.BdGraphService), i0.ɵɵinject(i3.EngineService)); }, token: PaintService, providedIn: "root" });
    return PaintService;
}());
export { PaintService };
